import isUndefined from 'lodash/isUndefined'
import isEmpty from 'lodash/isEmpty'
import $api from '@/plugins/axiosInstance.js'
import CONST from '@/const'

const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  LIST_SETTLEMENT: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({ method: 'get', url: '/settlement', params: payload
    })
      .then(result =>{
        return result.data
      })
    }
  },
  DETAIL_SETTLEMENT: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({ method: 'get', url: '/settlement/'+ payload.id, params: payload
    })
      .then(result =>{
        return result.data
      })
    }
  },
  POST_SETTLEMENT: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({ method: 'post', url: '/settlement', data: payload
    })
      .then(result =>{
        return result.data
      })
    }
  },
  PUT_SETTLEMENT: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({ method: 'put', url: '/settlement/'+ payload.id, data: payload
    })
      .then(result =>{
        return result.data
      })
    }
  },
  DELETE_SETTLEMENT: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({ method: 'delete', url: '/settlement/'+ payload.id, params: payload
    })
      .then(result =>{
        return result.data
      })
    }
  },
  EXCEL_SETTLEMENT: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({ method: 'get', url: '/settlement/export/list', params: payload
    })
      .then(result =>{
        return result
      })
    }
  },
}

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
}
